import { Injectable, signal, WritableSignal } from '@angular/core';

export interface PartialSuccessData {
  successMessage: string;
  failureMessage: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  error: WritableSignal<string | { code: string; error: string } | unknown> = signal(null);
  success: WritableSignal<string | null> = signal(null);
  partialSuccess: WritableSignal<PartialSuccessData | null> = signal(null);
  loader: WritableSignal<boolean> = signal(false);

  displaySuccess(value: string): void {
    this.success.set(null);
    this.success.set(value);
  }

  displayPartialSuccess(data: PartialSuccessData): void {
    this.partialSuccess.set(null);
    this.partialSuccess.set(data);
  }

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  displayError(error: string | { code: string; error: string } | unknown): void {
    this.error.set(null);
    this.error.set(error);
  }

  displayLoader(value: boolean): void {
    // Force changed value on boolean
    this.loader.set(!value);
    this.loader.set(value);
  }

  hideLoader(): void {
    this.displayLoader(false);
  }

  showLoader(): void {
    this.displayLoader(true);
  }
}
